import type { MediaFilter, MediaViewMode } from './types';

export const PAGE_SIZE = 20;

export const MEDIA_FILTERS: MediaFilter[] = ['all', 'folder', 'image', 'video', 'audio', 'document', 'file'];

export const DEFAULT_MEDIA_VIEW_MODE: MediaViewMode = 'grid';

export const FILE_GRID_BREAKPOINT = 1280;
export const GRID_GAP_PX = 16;
export const VIRTUAL_LIST_OVERSCAN = 4;
export const SECTION_ROW_HEIGHT = 24;
export const FOLDER_ROW_HEIGHT = 76;
export const FILE_ROW_HEIGHT = 252;
export const CASE_NAV_KEYS = {
  china: [
    'story_drama',
    'marketing_ads',
    'trending_event',
    'music_mv',
    'funny_prank',
    'education',
    'visual_art',
    // 'gaming',
    // 'others',
  ],
  global: [
    'story_drama',
    'marketing_ads',
    'trending_event',
    // 'music_mv',
    'funny_prank',
    // 'education',
    // 'visual_art',
    // 'gaming',
    // 'others',
  ],
} as const;
